export default "__VITE_ASSET__A_K2zzNS__"